import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-search-bar-active-toggle',
  templateUrl: './search-bar-active-toggle.component.html',
  imports: [FormsModule, TranslatePipe],
})
export class SearchBarActiveToggleComponent {
  @Input() active: boolean;
  @Output() toggled = new EventEmitter<void>();

  onCheckboxClicked(): void {
    this.toggled.emit();
  }
}
